export function formatMapName(exp, map, instance) {
    return exp + "-" + map + "-" + instance
}

export function extractMapName(name) {
    let split = name.split("-")
    return [split[0], split[1], split[2]]
}